import { Route } from "react-router-dom";
import WebContent from "./WebContent";
import WebContentList from "./WebContentList";

export default (
  <Route path="webContent" exact element={<WebContent />}>
    <Route index element={<WebContentList />} />
  </Route>
);
